export const home = {
  // Navigation
  nav_spreadsheet: "Spreadsheet",
  nav_guides: "Guides",
  nav_categories: "Kategorien",
  nav_review: "Bewertung",
  nav_shipping: "Versand",
  nav_safety: "Sicherheit",
  nav_blog: "Blog",
  nav_home: "Startseite",
  nav_shopping_guide: "Einkaufsführer",
  nav_about: "Über uns",
  nav_contact: "Kontakt",
  
  // Language selector
  lang_english: "English",
  lang_french: "Français",
  lang_german: "Deutsch",
  lang_danish: "Dansk",
  
  // Hero
  hero_eyebrow: "DIE ALLCHINABUY SPREADSHEET RESSOURCEN-HUB",
  hero_h1: "AllChinaBuy Spreadsheet — Produkte, Verkäufer und Kauf-Ressourcen schneller finden",
  hero_subheadline: "Entdecken Sie nützliche AllChinaBuy Spreadsheets, vertrauenswürdige Verkäufer-Ressourcen, Produkt-Guides, QC-Informationen, Versand-Tipps und Kauf-Guides — alles in einem einfachen Hub organisiert.",
  hero_cta_primary: "AllChinaBuy Spreadsheet erkunden",
  hero_cta_secondary: "Beliebte Ressourcen durchsuchen",
  hero_trust: "Unabhängige Ressource • Regelmäßig aktualisiert • Für einfachere Produktsuche",
  
  // Search Module
  search_title: "Finden Sie die AllChinaBuy Spreadsheet Ressource, die Sie brauchen",
  search_placeholder: "Produkte, Verkäufer, Versand, QC, Lager suchen...",
  search_button: "Suchen",
  search_popular: "Beliebte Suchen",
  search_popular_items: "Kleidung • Schuhe • Mode • QC • Versand • Verkäufer",
  
  // Spreadsheet Hub Section
  hub_h2: "AllChinaBuy Spreadsheet: Ihr Ausgangspunkt",
  hub_copy: "Suchen Sie nach Produkten, Verkäufern oder nützlichen Kauf-Informationen? Beginnen Sie mit dem AllChinaBuy Spreadsheet Hub und erkunden Sie organisierte Ressourcen nach Kategorie, Produkttyp und Suchabsicht.",
  hub_cta: "Den Spreadsheet Hub erkunden →",
  
  // Popular Categories
  categories_h2: "Beliebte AllChinaBuy Spreadsheet Kategorien",
  categories_clothing: "Kleidung",
  categories_clothing_desc: "Durchsuchen Sie das neueste AllChinaBuy Kleidungs-Spreadsheet mit vertrauenswürdigen Verkäufern, hochwertigen Artikeln und Größen-Guides für Streetwear und Freizeitkleidung.",
  categories_shoes: "Schuhe",
  categories_shoes_desc: "Erkunden Sie das AllChinaBuy Schuhe-Spreadsheet mit Sneakers, Stiefeln, Sandalen und mehr von verifizierten Verkäufern mit detaillierten QC-Informationen.",
  categories_fashion: "Mode",
  categories_fashion_desc: "Entdecken Sie trendige Mode-Artikel im AllChinaBuy Spreadsheet — kuratierte Kollektionen, saisonale Auswahl und Style-Guides.",
  categories_electronics: "Elektronik",
  categories_electronics_desc: "Finden Sie Elektronik und Gadgets im AllChinaBuy Produkt-Spreadsheet, inklusive Zubehör, Tech-Wearables und Alltagsgeräte.",
  categories_accessories: "Accessoires",
  categories_accessories_desc: "Kaufen Sie Gürtel, Taschen, Schmuck, Uhren und mehr über das AllChinaBuy Accessoires-Spreadsheet mit detaillierten Verkäufer-Bewertungen.",
  categories_sellers: "Vertrauenswürdige Verkäufer",
  categories_sellers_desc: "Greifen Sie auf das AllChinaBuy vertrauenswürdige Verkäufer-Spreadsheet zu mit verifizierten Bewertungen, Ratings und Produkt-Spezialitäten.",
  
  // Latest Resources
  resources_h2: "Neueste AllChinaBuy Ressourcen",
  resources_read: "Guide lesen →",
  pillar_h2: "AllChinaBuy Kern-Guides",
  pillar_subtitle: "Detaillierte Artikel zu jedem Teil der AllChinaBuy Einkaufsreise",
  
  // Buying Guides
  guides_h2: "AllChinaBuy Kauf-Guides",
  guides_qc: "QC Guide",
  guides_qc_desc: "Lernen Sie, wie Sie QC-Fotos anfordern, lesen und bewerten, bevor Sie Ihre AllChinaBuy Bestellungen versenden.",
  guides_shipping: "Versand-Guide",
  guides_shipping_desc: "Vergleichen Sie Versandmethoden, verstehen Sie Kosten und Zeitlinien und wählen Sie die beste Option für Ihr Land.",
  guides_warehouse: "Lager-Guide",
  guides_warehouse_desc: "Verstehen Sie, wie der AllChinaBuy Lager-Prozess funktioniert — Lagerung, Inspektion, Verpackung und Versand.",
  guides_seller: "Verkäufer-Guide",
  guides_seller_desc: "Tipps zum Finden zuverlässiger Verkäufer, Lesen von Bewertungen und Vermeiden häufiger Fehler beim Einkaufen.",
  guides_safety: "Sicherheits-Guide",
  guides_safety_desc: "Schützen Sie sich mit Best Practices für Kontosicherheit, Zahlungssicherheit und Betrugsbewusstsein.",
  
  // Review Section
  review_h2: "AllChinaBuy Bewertung",
  review_copy: "Suchen Sie nach einer unvoreingenommenen Übersicht? Erkunden Sie unsere AllChinaBuy Bewertung mit wichtigen Funktionen, Einkaufs-Workflow, Lager-Informationen, Versand-Überlegungen, Sicherheits-Tipps und wichtigen Dinge, die Sie vor der Nutzung der Plattform wissen sollten.",
  review_cta: "Die AllChinaBuy Bewertung lesen →",
  
  // Safety Section
  safety_h2: "Intelligenter einkaufen: AllChinaBuy Sicherheits-Guide",
  safety_copy: "Verstehen Sie vor dem Kauf Verkäufer-Verifizierung, QC-Fotos, Zahlungssicherheit, verdächtige Links, Kontoschutz und häufige Einkaufsrisiken.",
  safety_cta: "Den Sicherheits-Guide lesen →",
  
  // Final CTA
  final_cta_h2: "Bereit, AllChinaBuy Ressourcen zu erkunden?",
  final_cta_copy: "Starten Sie mit AllChinaBuy Spreadsheet und entdecken Sie Produkt-, Verkäufer-, Versand- und Kauf-Ressourcen für schnellere Recherche.",
  final_cta_primary: "AllChinaBuy Spreadsheet erkunden",
  final_cta_secondary: "Unsere Hauptwebsite besuchen",
  
  // Category Dropdown
  dropdown_title: "Einkaufskategorien",
  dropdown_all: "Alle Kategorien",
  
  // Main CTAs
  btn_main_site: "AllChinaBuy Spreadsheet",
  btn_buy_now: "Jetzt kaufen",
  
  // Footer
  footer_spreadsheet: "Spreadsheet",
  footer_guides: "Guides",
  footer_reviews: "Bewertungen",
  footer_shipping: "Versand",
  footer_safety: "Sicherheit",
  footer_resources: "Ressourcen",
  footer_about: "Über uns",
  footer_contact: "Kontakt",
  footer_privacy: "Datenschutz",
  footer_terms: "Nutzungsbedingungen",
  footer_disclaimer: "Haftungsausschluss",
  footer_disclaimer_text: "AllChinaBuy Spread ist eine unabhängige Informationsressource und ist nicht mit AllChinaBuy verbunden oder betrieben, es sei denn, es ist ausdrücklich angegeben.",
  footer_copyright: "© 2026 AllChinaBuy Spreadsheet. Alle Rechte vorbehalten.",
  
  // Meta
  meta_title: "AllChinaBuy Spreadsheet 2026: Kompletter Guide & Beste Ressourcen",
  meta_description: "Entdecken Sie AllChinaBuy Spreadsheet — Ihr unabhängiger Ressourcen-Hub für Produkte, Verkäufer, QC-Guides, Versand-Tipps und Kauf-Ressourcen. Regelmäßig aktualisiert.",
  
  // Category names (for dropdown)
  cat_shoes: "Schuhe",
  cat_hoodies: "Hoodies/Pullover",
  cat_tshirts: "T-Shirts",
  cat_jackets: "Jacken",
  cat_pants: "Hosen/Shorts",
  cat_headwear: "Kopfbedeckungen",
  cat_sets: "Sets",
  cat_underwear: "Unterwäsche",
  cat_jersey: "Trikots",
  cat_accessories: "Accessoires",
  cat_bags: "Taschen",
  cat_belts: "Gürtel",
  cat_perfumes: "Parfums",
  cat_other: "Sonstiges",
};